import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import { jsx as ___EmotionJSX } from "@emotion/core";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import { withTheme } from 'emotion-theming';
import IconDanger from "../Icon/IconDanger";
import IconSuccess from "../Icon/IconSuccess";
import IconWarning from "../Icon/IconWarning";
import { textWithThemeOverrides } from "../Text";
import { APPEARANCE } from "./constants";
import { DialogTitleRoot as Root, DialogTitleTitle } from "./styled";
import { dialogTitleTheme } from "./themes";
import { dialogTitlePropTypes } from "./propTypes";
var variantIcons = {
  danger: IconDanger,
  success: IconSuccess,
  warning: IconWarning
};

var DialogTitle = function DialogTitle(_ref) {
  var as = _ref.as,
      id = _ref.id,
      theme = _ref.theme,
      variant = _ref.variant,
      restProps = _objectWithoutPropertiesLoose(_ref, ["as", "id", "theme", "variant"]);

  var rootProps = _objectSpread({
    variant: variant
  }, restProps); // eslint-disable-next-line react/display-name


  var TitleContent = function TitleContent(props) {
    return ___EmotionJSX(DialogTitleTitle, _extends({
      id: id
    }, props));
  };

  var title = textWithThemeOverrides(_objectSpread({
    as: as || 'h1',
    displayName: 'DialogTitle',
    textComponent: TitleContent,
    theme: theme
  }, restProps));

  var Icon = function Icon() {
    return null;
  };

  if (variant) {
    Icon = variantIcons[variant];
  }

  return ___EmotionJSX(Root, rootProps, variant && ___EmotionJSX(Icon, {
    size: dialogTitleTheme(theme).DialogTitleIcon_size
  }), title);
};

var defaultProps = {
  appearance: APPEARANCE.h4
};
DialogTitle.displayName = 'DialogTitle';
DialogTitle.defaultProps = defaultProps;
DialogTitle.propTypes = process.env.NODE_ENV !== "production" ? dialogTitlePropTypes : {};
export default withTheme(DialogTitle);